import { Comment } from '../../store/comment';
import { CommentChildrenListParams } from '../../store/comment/children';
import { CommentListParams } from '../../store/comment/list';
import { PaginatedResponse } from '../../store/types';
import {
  DefaultFetchError,
  FetchCreate,
  FetchDelete,
  FetchGet,
  FetchSuccess,
  FetchUpdate,
  useFetchCreate,
  useFetchDelete,
  useFetchGet,
  useFetchUpdate,
} from '../fetch';

export const useCommentList = (): FetchGet<
  PaginatedResponse<Comment>,
  CommentListParams,
  DefaultFetchError
> =>
  useFetchGet('comments', {
    autoStart: false,
    startStateLoading: false,
    authorization: false,
  });

export const useCommentChildrenList = (
  parentId: string
): FetchGet<
  PaginatedResponse<Comment>,
  CommentChildrenListParams,
  DefaultFetchError
> =>
  useFetchGet(`comments/${parentId}/children`, {
    autoStart: false,
    startStateLoading: false,
    authorization: false,
  });

export const useCommentCreate = (
  parentId?: string
): FetchCreate<Partial<Comment>, DefaultFetchError> =>
  useFetchCreate(`comments${parentId ? `/${parentId}` : ''}`, {
    autoStart: false,
    startStateLoading: false,
  });

export const useCommentUpdate = (
  commentId: string
): FetchUpdate<
  FetchSuccess,
  DefaultFetchError,
  { text: string; fileIds: string[] }
> =>
  useFetchUpdate(`comments/${commentId}`, '', {
    autoStart: false,
    startStateLoading: false,
  });

export const useCommentDelete = (
  commentId: string
): FetchDelete<Comment, DefaultFetchError> =>
  useFetchDelete(`comments/${commentId}`, '', {
    autoStart: false,
    startStateLoading: false,
  });

export const useCommentReaction = (): FetchCreate<
  { id: string },
  DefaultFetchError,
  { status: boolean; commentId: string }
> =>
  useFetchCreate('comment-reactions', {
    autoStart: false,
    startStateLoading: false,
  });

export const useCommentReactionDelete = (): FetchDelete<
  { id: string },
  DefaultFetchError
> =>
  useFetchDelete('comment-reactions', '', {
    autoStart: false,
    startStateLoading: false,
  });
